module.exports = __webpack_public_path__ + "img/maps4us.ec68ca87.svg";